/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';
import useTranslations from '../../../../hooks/useTranslations';
import jobPostingPropType from '../../../../prop_types/job_postings';
import MapPin from '../../../_atoms/MapPin';
import { JobMapContext } from '../JobMapContext';
import {
  CustomPin,
  JobIcon,
  JobInfo,
  JobListItemContainer,
  JobLocation,
  JobLogo,
  JobTitle,
} from './styles';

const t = useTranslations('JobMapJobListItem');
function JobMapJobListItem({ jobPosting }) {
  const { getBrand, primaryColor, setCurrentJob, mapPinMode, mapPinUrl } =
    useContext(JobMapContext);
  let logo = jobPosting.logo_thumb_url;
  let color = primaryColor;
  const brand = getBrand(jobPosting.brand?.id);
  if (brand) {
    logo = brand.avatar_small_url;
    color = brand.primary_color;
  }
  let icon = <JobLogo src={logo} alt={jobPosting.brand?.name} />;
  if (jobPosting.locations.length > 0 && !jobPosting.remote) {
    icon = (
      <MapPin
        color={color}
        imageUrl={logo}
        unmapped={jobPosting.is_unmappable}
      />
    );
  }
  if (mapPinMode === 'custom' && mapPinUrl) {
    icon = <CustomPin src={mapPinUrl} alt='Map pin' />;
  }

  return (
    <JobListItemContainer onClick={() => setCurrentJob(jobPosting)}>
      <JobIcon>{icon}</JobIcon>
      <JobInfo>
        <JobTitle>{jobPosting.title}</JobTitle>
        {jobPosting.locations.map((l, index) => (
          <JobLocation key={l.id}>
            {index > 0 ? ', ' : ''}
            {l.canonical_name}
            {jobPosting.remote && <>{` - ${t('job_maps.remote')}`}</>}
          </JobLocation>
        ))}
      </JobInfo>
    </JobListItemContainer>
  );
}

JobMapJobListItem.propTypes = {
  jobPosting: jobPostingPropType.isRequired,
};

function JobMapJobListItemFallback() {
  return <JobListItemContainer />;
}

export default exportWithBoundary(JobMapJobListItem, JobMapJobListItemFallback);
